export const MMS_IMAGE_MAX_BYTES = 200 * 1024;
export const MMS_IMAGE_MAX_WIDTH = 1500;
export const MMS_IMAGE_MAX_HEIGHT = 1440;

export const readImageSize = (file: File): Promise<{ width: number; height: number }> => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const image = new Image();
  image.onload = () => {
    URL.revokeObjectURL(url);
    resolve({ width: image.naturalWidth, height: image.naturalHeight });
  };
  image.onerror = () => {
    URL.revokeObjectURL(url);
    reject(new Error('이미지를 읽을 수 없습니다.'));
  };
  image.src = url;
});

export const validateMmsImage = async (file: File): Promise<string | null> => {
  if (file.type !== 'image/jpeg') return 'JPG 이미지만 첨부할 수 있습니다.';
  if (file.size > MMS_IMAGE_MAX_BYTES) return '이미지 크기는 200KB 이하여야 합니다.';
  try {
    const { width, height } = await readImageSize(file);
    if (!width || !height) return '이미지를 읽을 수 없습니다.';
    if (width > MMS_IMAGE_MAX_WIDTH || height > MMS_IMAGE_MAX_HEIGHT) return '이미지 크기는 1500×1440px 이하여야 합니다.';
    return null;
  } catch {
    return '이미지를 읽을 수 없습니다.';
  }
};

export const validateMmsSubject = (subject: string): string | null => {
  if (new Blob([subject]).size > 40) return 'MMS 제목은 40byte 이하여야 합니다.';
  if (/#\{[^}]*\}/.test(subject)) return 'MMS 제목에는 변수를 사용할 수 없습니다.';
  return null;
};
